import { useGetPermissionGroupsQuery } from 'data/__generated__';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';

import { permissionGroupsColumns, type PermissionGroupRow } from '../constants/permissionGroupsColumns';

export const PermissionGroupsList = () => {
    const { loading, data, error } = useGetPermissionGroupsQuery();

    if (loading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (!data || error) {
        throw new Error('Une erreur est survenue lors de la récupération des groupes de permissions');
    }

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<PermissionGroupRow>
                columns={permissionGroupsColumns}
                data={data.permissionGroups}
                filterMode="client"
                getRowId={(row) => row.slug}
                getRowLink={(row) => `/permission-group/${row.slug}`}
                searchPlaceholder="Nom du groupe"
            />
        </div>
    );
};
